export const coupon = {
  namespaced: true,
  state: {
    externalCoupons: [],
    externalCoupon: {},
    masterCoupon: {},
  },
  getters: {
    externalCoupons(state) {
      return state.externalCoupons;
    },
    externalCoupon(state) {
      return state.externalCoupon;
    },
    masterCoupon(state) {
      return state.masterCoupon;
    },
  },
  mutations: {
    setExternalCoupons(state, externalCoupons) {
      state.externalCoupons = externalCoupons;
    },
    setExternalCoupon(state, externalCoupon) {
      state.externalCoupon = externalCoupon;
    },
    setMasterCoupon(state, masterCoupon) {
      state.masterCoupon = masterCoupon;
    },
  },
};
